import React from 'react';
import { FaPhone } from 'react-icons/fa';
import './FloatingButtons.css';

const FloatingButtons = () => {
  const copyPhoneNumber = () => {
    navigator.clipboard.writeText('+91 9205279444').then(() => {
      alert('Phone number copied to clipboard: +91 9205279444');
    }).catch(() => {
      alert('Phone number: +91 9205279444');
    });
  };

  return (
    <div className="floating-buttons">
      <div className="phone-display" onClick={copyPhoneNumber} title="Click to copy phone number">
        <FaPhone size={28} />
        <span className="phone-number">+91 9205279444</span>
      </div>
    </div>
  );
};

export default FloatingButtons; 